export const getNotifications = state => {
  return state.notifications
}

export const getCountUnreadNotifications = state => {
  return state.unread
}
